export default function ConsentFigure() {
  return (
    <figure className="pt-4 space-y-4" data-testid="sms-consent-figure">
      <div className="rounded-2xl border border-white/10 bg-white/[0.03] overflow-hidden">
        <img
          src="/sms-consent-screenshot.webp"
          alt="Agentica Docu Flow account settings page showing the 'Call Maya by phone' card with an unchecked-by-default SMS consent checkbox"
          className="w-full h-auto"
          loading="lazy"
          data-testid="sms-consent-full-image"
        />
      </div>
      <div className="rounded-2xl border border-[#9d6bff]/30 bg-white/[0.03] overflow-hidden shadow-[0_0_60px_-20px_rgba(157,107,255,0.35)]">
        <img
          src="/sms-consent-detail.webp"
          alt="Close-up of the SMS consent checkbox and disclosure text in Agentica Docu Flow"
          className="w-full h-auto"
          loading="lazy"
          data-testid="sms-consent-detail-image"
        />
      </div>
      <figcaption className="text-white/45 text-xs leading-relaxed">
        <span className="text-white/70">Example opt-in flow — Agentica Docu Flow.</span> SMS consent is collected through a
        distinct, stand-alone checkbox that is <span className="text-white/70">unchecked by default</span> and separate from
        account creation, terms acceptance, and any purchase. The user must save their mobile number and deliberately check the box
        reading: &ldquo;I agree to receive text messages from Agentica Docu Flow (Maya) at this number, such as document status
        updates, replies to my questions and secure screen-share links. Message frequency varies. Message and data rates may apply.
        Reply STOP to opt out, HELP for help. Consent is not a condition of purchase.&rdquo; No messages are sent until this box is
        checked.
      </figcaption>
    </figure>
  );
}
